var React = require('react');

function IconHealth (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.96 9.969c.574 0 1.04.462 1.04 1.031 0 .57-.466 1.031-1.04 1.031h-3.19l-1.774 6.449a2.084 2.084 0 0 1-2.556 1.447 2.072 2.072 0 0 1-1.46-1.447L8.011 4.063 6.238 10.51a2.079 2.079 0 0 1-2.009 1.52H1.041C.466 12.031 0 11.57 0 11c0-.57.466-1.031 1.04-1.031h3.19L6.003 3.52a2.072 2.072 0 0 1 1.46-1.447c1.11-.3 2.254.348 2.557 1.447l3.967 14.417 1.774-6.448a2.079 2.079 0 0 1 2.009-1.52h3.188z","fill":"currentColor","fillRule":"nonzero"}));
}

IconHealth.defaultProps = {"width":"22","height":"22"};

module.exports = IconHealth;

IconHealth.default = IconHealth;
